import { Typography } from '@mui/material'
import type { components } from 'api/playerPayback/api'
import { Page } from 'components/Shared/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { isNil } from 'lodash'
import { getLastUpdated } from 'utils/util'

export const ResourcesDetailsHeader = ({
  resource,
  actionButton,
  children,
}: {
  resource: components['schemas']['FullResourceDTO']
  actionButton?: React.ReactNode
  children?: React.ReactNode
}) => {
  if (!resource.id) {
    return <Typography>Resource Id must not be null.</Typography>
  }

  return (
    <Page
      header={
        <PageHeader
          title={isNil(resource.title) ? 'Unknown' : resource.title}
          subtitle={getLastUpdated(resource.modifiedOn)}
          backText="Resources"
          backPath="/JJUpdates/Resources"
          isSecondary={true}
          actionButton={actionButton}
        />
      }
    >
      {children}
    </Page>
  )
}
